import { Box, Button } from "@chakra-ui/react";
import type { ReactNode } from "react";

type Props = { onBack: () => void; children: ReactNode };

// "Atrás" on the left, the step's main action (children) on the right. Sticky
// so a long table does not push it out of reach.
const StepFooter = ({ onBack, children }: Props): JSX.Element => (
  <Box
    position="sticky"
    bottom="0"
    zIndex={1}
    bg="white"
    borderTop="1px solid #ebecef"
    py="3"
    display="flex"
    justifyContent="space-between"
    gap="3"
  >
    <Button variant="outline" onClick={onBack}>
      Atrás
    </Button>
    {children}
  </Box>
);

export default StepFooter;
